<template>
  <ul class="c-progress" :class="cssClass">
    <li
      v-for="(item, index) in items"
      :key="index"
      class="c-progress__item"
      :class="{ 'is-current': item.current }"
    >
      <div class="c-progress__number">
        {{ index + 1 }}
      </div>
      <div class="c-progress__label">
        <span>{{ item.label }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    variant: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return { [this.type]: this.type };
    }
  }
};
</script>
